import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Plus, Trash2, ChevronRight, CalendarDays } from "lucide-react";
import { Shell } from "@/components/Shell";
import { loadEvents, newEvent, upsertEvent, removeEvent } from "@/data/events";
import { belongsToCurrent } from "@/data/business";

export default function EventsPage() {
  const navigate = useNavigate();
  const [list, setList] = useState(() => loadEvents().filter(belongsToCurrent));
  const create = () => navigate(`/eventi/${upsertEvent(newEvent()).id}`);
  const del = (id) => {
    if (!window.confirm("Eliminare questa scheda evento?")) return;
    removeEvent(id);
    setList(loadEvents().filter(belongsToCurrent));
  };
  return (
    <Shell header={<button className="btn btn-ghost !min-h-[44px] text-sm" onClick={() => navigate("/")} data-testid="events-back-btn"><ArrowLeft size={16} /> Elenco</button>}>
      <div className="fade-up">
        <p className="eyebrow">Sala + cucina</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-[#2C221E] mt-2">Schede evento</h1>
        <p className="text-[#5C4D46] mt-3 max-w-xl">Una scheda per ogni evento: timeline, ruoli, briefing e checklist. Si stampa e si appende in cucina e in sala.</p>
        <button className="btn btn-primary mt-8 text-lg !min-h-[64px] !px-9" onClick={create} data-testid="new-event-btn"><Plus size={22} /> Nuova scheda evento</button>
      </div>
      <section className="mt-12">
        {list.length === 0 ? (
          <div className="card p-8 text-center text-[#7A6B63]" data-testid="events-empty">Nessuna scheda ancora.</div>
        ) : (
          <div className="grid gap-4" data-testid="events-list">
            {list.map((e) => (
              <div key={e.id} className="card p-5 flex items-center gap-4" data-testid={`event-row-${e.id}`}>
                <div className="flex-none w-12 h-12 rounded-2xl bg-[#2D4030] text-[#FAF6F0] grid place-items-center"><CalendarDays size={22} /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-serif text-xl font-semibold text-[#2C221E] truncate">{e.title || "Evento senza titolo"}</p>
                  <p className="text-sm text-[#7A6B63]">{e.date ? new Date(e.date).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" }) : "Data da definire"} · {e.type}{e.guests ? ` · ${e.guests} coperti` : ""}</p>
                </div>
                <button className="btn btn-ghost !min-h-[48px] !px-4" onClick={() => del(e.id)} aria-label="Elimina" data-testid="delete-event-btn"><Trash2 size={18} /></button>
                <button className="btn btn-olive !min-h-[48px]" onClick={() => navigate(`/eventi/${e.id}`)} data-testid="open-event-btn">Apri <ChevronRight size={18} /></button>
              </div>
            ))}
          </div>
        )}
      </section>
    </Shell>
  );
}
